import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { usePqrTimesForm } from './hook';
import { PqrTimesData } from './data';
import { PqrTimesDate } from './dateTimes';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PQR_TIMES,
    PQR_TIMES_DETAIL,
    PQR_TIMES_EDIT,
    PQR_TIMES_NEW,
} from '../../../../../routes/paths';
import { PqrTimesParamsHistorical } from '../historical';

export const PqrTimesForm = () => {
    const {
        pqrTimes,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrTimesData,
        setFormikPqrTimesDates,
        pqrTimesHistorical,
        showHistorical,
        setShowHistorical,
    } = usePqrTimesForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    pqrTimes && pqrTimes.id
                        ? 'Editar estado PQR'
                        : 'Crear estado PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrTimes?.id || ''}
                        buttonCreate={{
                            show: Boolean(pqrTimes?.id),
                            route: PQR_TIMES_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_TIMES,
                        }}
                        buttonUpdate={{
                            show: !Boolean(pqrTimes?.id),
                            route: PQR_TIMES_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_TIMES_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrTimes?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <PqrTimesParamsHistorical
                        historical={pqrTimesHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <PqrTimesData
                data={pqrTimes}
                onChangeFormik={(formik) => setFormikPqrTimesData(formik)}
            />
            <PqrTimesDate
                data={pqrTimes}
                onChangeFormik={(formik) => setFormikPqrTimesDates(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
